import React from 'react';
import { marqueeItems } from '../data/mock';

export default function Marquee() {
  const items = [...marqueeItems, ...marqueeItems, ...marqueeItems, ...marqueeItems];
  return (
    <div className="w-full overflow-hidden py-6 bg-splash-cream border-y border-splash-sand/60">
      <div className="marquee-track flex whitespace-nowrap gap-14">
        {items.map((t, i) => (
          <span
            key={i}
            className="uppercase tracking-[0.25em] font-display font-semibold text-splash-coral text-lg md:text-2xl inline-flex items-center gap-14"
          >
            {t}
            <span className="inline-block w-2 h-2 rounded-full bg-splash-coral" />
          </span>
        ))}
      </div>
    </div>
  );
}
